import { Group, Stack } from '@mantine/core';

import DeleteWorkspace from './DeleteWorkspace/DeleteWorkspace';
import TransferWorkspaceOwnership from './TransferWorkspaceOwnership/TransferWorkspaceOwnership';
import EditWorkspaceName from './EditWorkspaceName/EditWorkspaceName';
import EditWorkspaceLogo from './EditWorkspaceLogo/EditWorkspaceLogo';

import useWorkspaceSettings from './useWorkspaceSettings';

const WorkspaceSettings = ( { workspaceID }: { workspaceID: number } ) => {
	const {
		workspace,
		isOwner,
		canTransferOwnership,
		canEditWorkspace,
		hideTransferOwnership
	} = useWorkspaceSettings( { workspaceID } );

	return (
		<Stack maw={800} spacing={25}>
			<EditWorkspaceName
				workspace={workspace}
				readOnly={!canEditWorkspace}
				showCustomBrandingCallout={workspace.hasCustomBranding}
			/>
			<EditWorkspaceLogo
				workspace={workspace}
				readOnly={!canEditWorkspace}
			/>
			{isOwner
				&& (
					<Group spacing={35} noWrap grow align="stretch">
						{!hideTransferOwnership && (
							<TransferWorkspaceOwnership
								workspaceID={workspaceID}
								canTransferOwnership={canTransferOwnership}
							/>
						)}
						<DeleteWorkspace workspaceID={workspaceID} />
					</Group>
				)}
		</Stack>
	);
};

export default WorkspaceSettings;
